import React, { useContext, useEffect, useState } from 'react';
import { Refresh } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { MenuButtonStyle } from './styles';
import ToolButton from '../../../../components/ToolButton';
import { formatDate } from '../../../../helpers/dateUtils';
import { UserContext } from '../../../../context/UserContext';
import { DashboardContext, REFRESH_COOLDOWN_IN_MILLIS, REFRESH_DASHBOARD_KEY } from '../../DashboardContext';

const RefreshDashboard = () => {
    const { t } = useTranslation();
    const { locale } = useContext(UserContext);
    const { refreshDate, refreshDashboard } = useContext(DashboardContext);
    const [refreshDisabled, setRefreshDisabled] = useState(false);

    useEffect(() => {
        const refreshCooldown = parseInt(localStorage.getItem(REFRESH_DASHBOARD_KEY) || '0', 10);
        if (refreshCooldown > Date.now()) {
            setRefreshDisabled(true);
            setTimeout(() => setRefreshDisabled(false), refreshCooldown - Date.now());
        }
    }, [refreshDashboard]);

    return (
        <ToolButton
            buttonStyle={{
                ...MenuButtonStyle,
                color: 'text.secondary',
                backgroundColor: 'background.paper',
            }}
            iconElement={<Refresh />}
            onClick={async () => {
                refreshDashboard();
                setRefreshDisabled(true);
                setTimeout(() => setRefreshDisabled(false), REFRESH_COOLDOWN_IN_MILLIS);
            }}
            text={refreshDate ? formatDate(new Date(refreshDate).toString(), locale) : formatDate(new Date().toString(), locale)}
            tooltip={t('screens.dashboarding.refresh')}
            active={false}
            disabled={refreshDisabled}
            hideTextOnMobileView={false}
        />
    )
}

export default RefreshDashboard;
